export const iconFontAwesomeConstructionWrench = (
	<i className="fa-solid fa-wrench"></i>
);
